import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { StickyTrigger } from 'fw/components';
import * as Notifications from 'fw/globals/Notifications';

class Comments extends React.Component
{
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	handleClick = (e, name) => {
		e.stopPropagation();
		const accname = this.props.dependentValues.accountName;
		Notifications.success(`Row clicked: ${accname}. Redirecting to ${name}...`);
	}

    render() {
		const popover = (
			<div>
				<a onClick={(e) => {this.handleClick(e, "Go to Soils Lookup")}} className="pull-right" style={{cursor: "pointer"}}>Go to Soils Lookup</a><br />
				<a onClick={(e) => {this.handleClick(e, "Go to Plants Lookup")}} className="pull-right" style={{cursor: "pointer"}}>Go to Plants Lookup</a><br />
				<a onClick={(e) => {this.handleClick(e, "Go to Manure Lookup")}} className="pull-right" style={{cursor: "pointer"}}>Go to Manure Lookup</a><br />
		  	</div>);

		return (
			<React.Fragment>
				<StickyTrigger placement="left" title="Actions Menu" component={popover}>
					<Glyphicon glyph="link"/>
				</StickyTrigger>
			</React.Fragment>
		)
    }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/fw/components/formatter/Comments.js